import React from 'react';

const Agent = () => {
    return (
        <div>
            <h1>Agent Registration</h1>
            <p>Welcome to the agent registration page. Please fill out the necessary information to register as an agent.</p>
            {/* Add registration form or additional content here */}
        </div>
    );
};

export default Agent;